import React from "react";
import ContactUsForm from "../../components/ContactUsForm";
import Banner from "../../components/Banner";

const ContactSec = () => {
  return (
    <>
      <ContactUsForm imgDiv={false}></ContactUsForm>
    </>
  );
};

export default ContactSec;
